import React from 'react'
import { AssetDeliveryContainer, AssetDeliveryGroup } from 'components/shared/AssetDelivery'
import { createGroups } from 'components/shared/AssetDelivery/utils'
import UploaderProvider from './Uploader/UploaderContext'
import { PhotoProduct } from './types'
import Uploader from './Uploader'

interface Props {
  product: PhotoProduct
}

function FileDelivery({ product }: Props) {
  if (product.state !== 'booked') {
    const groups = createGroups(
      product.assetDeliveries.map((asset: any) => ({
        id: asset.id,
        asset,
      }))
    )

    return (
      <AssetDeliveryContainer>
        {groups.map(([id, uploaders]: any) => (
          <AssetDeliveryGroup
            key={id}
            preDefinedLabels={product.availablePhotoLabels}
            uploaders={uploaders}
          />
        ))}
      </AssetDeliveryContainer>
    )
  }

  return (
    <div className="file-delivery">
      <UploaderProvider product={product}>
        <Uploader />
      </UploaderProvider>
    </div>
  )
}

export default FileDelivery
